import { throttle } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';

import { useTimeout } from './useTimeout';

const defaultInterval = 60 * 60 * 1000; // 1 hour
const defaultEvents: (keyof WindowEventMap)[] = [
    'mousemove',
    'mousedown',
    'resize',
    'keydown',
    'touchstart',
    'wheel',
];

export interface UseIdleOptions {
    immediate?: boolean;
    events?: (keyof WindowEventMap)[];
}

export const useIdle = (
    interval: number = defaultInterval,
    options: UseIdleOptions = {}
) => {
    const { immediate = true, events = defaultEvents } = options;
    const [isIdle, setIsIdle] = useState(false);

    const inactive = useCallback(() => {
        setIsIdle(true);
    }, []);

    const { reset } = useTimeout(inactive, interval, { immediate });

    const enactive = useCallback(() => {
        setIsIdle(false);
        reset();
    }, [reset]);

    useEffect(() => {
        const throttledEnactive = throttle(enactive, 5000);

        const eventHandler = () => {
            throttledEnactive();
        };

        events.forEach((event) => {
            window.addEventListener(event, eventHandler);
        });

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, eventHandler);
            });
            throttledEnactive.cancel();
        };
    }, [events, enactive]);

    return { isIdle };
};
